import axios from "axios";
import { getAuthToken } from "./helper";
import { logError } from "./logger";

const url = window.location.pathname;
const parts = url.split("/");
const hotelCode = JSON.parse(localStorage.getItem("reservation")!)?.hotelCode;

const AXIOS_RESERVATION = axios.create({
  baseURL: process.env.REACT_APP_RESERVATION,
});

AXIOS_RESERVATION.interceptors.request.use(
  (config) => {
    const authToken = getAuthToken();
    config.headers["hotelcode"] = 'shmv';
    if (authToken) {
      config.headers["Authorization"] = authToken;
    }
    //add from local host
    // config.headers["hotelcode"] = hotelCode;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

AXIOS_RESERVATION.interceptors.response.use(
  (response) => response,
  (error) => {
    logError('API error', {
      url: error.config?.url,
      method: error.config?.method,
      status: error.response?.status,
      message: error.response?.data?.result?.message,
    });
    if (error.response && error.response.status >= 500) {
      window.location.href = "/server-error";
    }
    return Promise.reject(error);
  }
);

const AXIOS_HOSPITALITY = axios.create({
  baseURL: process.env.REACT_APP_HOSPITALITY,
});

AXIOS_HOSPITALITY.interceptors.request.use(
  (config) => {
    const authToken = getAuthToken();
    config.headers["hotelcode"] = 'shmv';
    if (authToken) {
      config.headers["Authorization"] = authToken;
    }
    //add from local host
    // config.headers["hotelcode"] = hotelCode;
    return config;
  },
  (error) => Promise.reject(error)
);

AXIOS_HOSPITALITY.interceptors.response.use(
  (response) => response,
  (error) => {
    logError('API error', {
      url: error.config?.url,
      method: error.config?.method,
      status: error.response?.status,
      message: error.response?.data?.result?.message,
    });
    if (error.response && error.response.status >= 400) {
      window.location.href = "/server-error";
    }
    Promise.reject(error)
  }
);

export { AXIOS_RESERVATION, AXIOS_HOSPITALITY };
